<template>
	<div class="drawer">
		<el-drawer
		size="500px"
		title="疫苗实施日期"
		:visible.sync="drawerStatus"
		@close='close'
		>
			<el-form ref="dialogPlanForm" style="padding-top:0px;">
				<el-row>
					<el-col :span="6" :offset="2">
						<el-form-item label="计划名称：" :label-width="formLabelWidth">
							<el-input v-model="dialogPlanForm.planName" size="small" style="width:220px" placeholder="请输入计划名称"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6" :offset="2">
						<el-form-item label="实施日期：" :label-width="formLabelWidth">
							<el-date-picker
							v-model="dialogPlanForm.planDate_dateObj"
							type="date"
							style="width:220px"
							:clearable="false"
							size="small"
							placeholder="选择日期">
						</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6" :offset="2">
						<el-form-item label="距离下一次计划：" :label-width="formLabelWidth">
							<el-input v-model="dialogPlanForm.intervalDays" style="width:220px" size="small">
								<template slot="append">天</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth: '130px',
				dialogPlanForm:{
					planName:'',
					planDate:'',
					intervalDays:'',
					planMoney:0,
				},
			}
		},
		props:{
			row:{
				default:{}
			},
			detail:{
				default:{}
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true
			})
		
                console.log(this.row,"row");
				this.dialogPlanForm={
					planId:this.row.planId,
					planName:this.row.planName,
					planDate_dateObj:new Date(this.row.handlerTime*1000),
					planDate:this.row.handlerTime,
					intervalDays:this.row.intervalDays,
					planMoney:this.row.planMoney,
					remark:this.row.remark
				}
			
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			// 保存基本信息
			submit() {
				let loading = this.$loading()
				if(this.dialogPlanForm.planId){  // 编辑
					let params = {
						"planId": this.dialogPlanForm.planId,
						"planName": this.dialogPlanForm.planName,
						"planDate": this.dialogPlanForm.planDate_dateObj.getTime().toString().substr(0,10),
						"intervalDays": this.dialogPlanForm.intervalDays,
					}
					this.$http.get('/api/MedicalPackage/Plan/UpdateCompletePlanDate', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit("submit",{type:'success'})
						}
					})
				}
				
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: $mainColor;
				}
			}
		}
	}
	
</style>
